import { CommonModule } from "@angular/common";
import { AfterViewInit, Component, Input, OnInit, output } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import type { IObjectCollection } from "@nova/common-interfaces";
import {
  createEmptyObjectCollection,
  IReference,
  isObjectCollection,
} from "@nova/common-interfaces";
import { CommonComponent } from "../../common/common.component.mjs";

@Component({
    selector: "app-common-reference-card",
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    templateUrl: "./reference-card.component.html",
    styleUrls: ["./reference-card.component.scss"]
})
export class CommonReferencesCard extends CommonComponent implements OnInit, AfterViewInit {
  // #region Properties (7)

  @Input()
  public canEdit = true;
  public createReference = false;
  public newReference: IReference = {} as IReference;
  public newRow = false;
  @Input()
  public references: IObjectCollection<IReference> =
    createEmptyObjectCollection<IReference>();
  public referencesChanged = output<IObjectCollection<IReference>>();
  public rowEdit = -1;

  // #endregion Properties (7)

  // #region Constructors (1)

  constructor() {
    super();
  }

  // #endregion Constructors (1)

  // #region Public Methods (4)

  public addReference(event: any) {
    this.newReference.createdAt = Date.now();
    this.createReference = true;
  }

  public cancelReference() {
    this.createReference = false;
    this.rowEdit = -1;
    if (this.newRow) {
      this.references.data.splice(this.references.length - 1, 1);
      this.references.length = this.references.data.length;
    }
  }

  public ngOnInit() {}

  ngAfterViewInit(): void {
    if (isObjectCollection(this.references) &&
     Array.isArray(this.references.data))
    {
      if (this.references.data.length > 0)
      {
        this.hasData = true;
      }
    }
  }

  public saveReference() {
    this.references.data.push({ ...this.newReference } as IReference);
    this.references.length = this.references.data.length;

    this.referencesChanged.emit(this.references);

    this.newReference = {} as IReference;
    this.createReference = false;
  }

  // #endregion Public Methods (4)
}
